import { Alert } from '@seeqdev/qomponents';

interface AlertWarningProps {
  children: React.ReactNode;
  extraClassNames?: string;
}

export const AlertWarning: React.FunctionComponent<AlertWarningProps> = ({ children, extraClassNames }) => {
  return (
    <Alert dismissible={false} variant="warning" extraClassNames={extraClassNames}>
      {children}
    </Alert>
  );
};
